module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('div', {
    staticClass: "mine-box-title"
  }, [_vm._v("裁判长报备")]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "closable": false,
      "title": "裁判长申报联系人： 寇磊 18551717417",
      "type": "warning"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mine-content"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goDetail({
          id: 0
        })
      }
    }
  }, [_vm._v("新增报备\n          ")]), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "审核中",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "审核通过",
      "name": "2"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "0"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.list,
      "row-key": "id",
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "报名会议",
      "fixed": "left",
      "prop": "title"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("赛事名称：" + _vm._s(scope.row.saiqu_name))]), _vm._v(" "), _c('p', [_vm._v("日期：" + _vm._s(scope.row.date))]), _vm._v(" "), _c('p', [_vm._v("姓名：" + _vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "zhuantai"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('el-tag', [_vm._v("\n            审核中\n          ")]) : (scope.row.status == 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("\n            审核通过\n          ")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('el-popover', {
          attrs: {
            "placement": "top-start",
            "title": "管理员备注",
            "content": scope.row.admin_note || '暂无备注',
            "width": "200",
            "trigger": "hover"
          }
        }, [_c('el-tag', {
          attrs: {
            "slot": "reference",
            "type": "danger"
          },
          slot: "reference"
        }, [_vm._v("\n\n            审核未通过\n              "), _c('i', {
          staticClass: "el-icon-warning-outline"
        })])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提交时间",
      "prop": "riqi"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.create_time_str) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "prop": "caozuo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 2) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.upload(scope.row)
            }
          }
        }, [_vm._v("赛后资料上传\n          ")]) : _c('el-button', {
          staticClass: "look-order",
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.goDetail(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": parseInt(_vm.row.currentpage),
      "page-size": _vm.params.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.row.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67ca961b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cpz/CpzApplyList.vue
// module id = 1515
// module chunks = 0